<ix-layout-grid class="h-100 d-flex flex-column">
  <ix-row>
    <ix-col size="12">
      <ix-content-header
        [hasBackButton]="true"
        (backButtonClick)="onBackButtonClick()"
        [headerTitle]="'um.menu_access_request' | translate"
        id="editAccessRequestHeader">
      </ix-content-header>
    </ix-col>
  </ix-row>

  @if (loading) {
    <ix-row>
      <ix-col class="d-flex flex-row justify-content-center">
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  }

  @if (!loading && accessRequest && !isAlreadyHandled) {
    <div class="input-field-size-max">
      <ix-row>
        <ix-col size="12">
          <ix-key-value-list>
            <ix-typography format="h4" class="mb-2">
              {{ 'um.category_user_profile' | translate }}
            </ix-typography>
            @for (field of fields; track field.labelKey) {
              <ix-key-value
                [labelPosition]="'left'"
                [label]="field.labelKey | translate"
                [value]="field.value">
              </ix-key-value>
            }
            <ix-key-value
              [labelPosition]="'left'"
              [label]="'um.roles_title' | translate">
              <span slot="custom-value" class="d-flex flex-wrap gap-1">
                @for (role of roleItems; track role.value) {
                  <ix-pill variant="custom" [outline]="true">{{ role.label }}</ix-pill>
                }
              </span>
            </ix-key-value>
          </ix-key-value-list>
            <div class="d-flex gap-2 mt-4 justify-content-end">
              <ix-button
                variant="secondary"
                (click)="openDeclineModal()"
                [disabled]="submitting"
                onkeypress=""
                id="declineAccessButton">
                {{ 'um.access_requests.decline_access' | translate }}
              </ix-button>
              <ix-button
                variant="primary"
                (click)="openGrantModal()"
                [loading]="submitting"
                onkeypress=""
                id="grantAccessButton">
                {{ 'um.access_requests.grant_access' | translate }}
              </ix-button>
            </div>
        </ix-col>
      </ix-row>
    </div>
  }

  @if (!loading && accessRequest && isAlreadyHandled) {
    <ix-row>
      <ix-col size="12">
        <ix-empty-state
          [header]="'um.access_requests.already_handled_header' | translate"
          [subHeader]="'um.access_requests.already_handled_sub_header' | translate"
          icon="success">
        </ix-empty-state>
      </ix-col>
    </ix-row>
  }

  @if (!loading && !accessRequest) {
    <ix-row>
      <ix-col size="12">
        <ix-empty-state
          [header]="'um.access_requests.not_found' | translate"
          icon="user">
        </ix-empty-state>
      </ix-col>
    </ix-row>
  }
</ix-layout-grid>
